// Sugalarm — meal-photo feature-flag probe.
//
// Polls /api/health once on mount, reads `photo.enabled`, and returns the
// boolean. Default `false`; flips true only once the server confirms the
// photo-estimate feature is configured (ANTHROPIC_API_KEY set) — mirrors
// `useDevInjectEnabled`'s pattern so a photo-capture affordance never
// flashes on before the server has confirmed it's available.

import { useEffect, useState } from "react";

import { apiUrl } from "../env";

export function usePhotoEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(apiUrl("/api/health"), { cache: "no-store" });
        if (!res.ok) return;
        const data = (await res.json()) as { photo?: { enabled?: boolean } };
        if (cancelled) return;
        setEnabled(Boolean(data?.photo?.enabled));
      } catch {
        // Network blip — stay disabled, indistinguishable from "flag off".
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return enabled;
}
